import { render, staticRenderFns } from "./TdtMapPoint.vue?vue&type=template&id=b570a5c8"
import script from "./TdtMapPoint.vue?vue&type=script&lang=js"
export * from "./TdtMapPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports